import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AppContext = React.createContext({})

const AppProvider = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [params, setParams] = React.useState({});
    useEffect(() => {
        const urlParams = readAllUrlParams();
        setParams(urlParams);
    }, []);

    useEffect(() => {
        if(params?.utm_source && params?.utm_source === "mobile") {
            navigate('/games', { replace: true });
        }
    }, [params]);

    const readAllUrlParams = () => {
        const urlParams = new URLSearchParams(location.search);
        const params = {};
        for (const [key, value] of urlParams.entries()) {
            params[key] = value;
        }
        return params;
    };


    return children;
};

export default AppProvider;


export const useAppContext = () => {
    return useContext(AppContext);
};

